import { Directive, ElementRef, Renderer2, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appVideoAspectRatio]'
})
export class VideoAspectRatioDirective {

  @Input() inlinePlayer  = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('loadedmetadata')
  onLoadedMetadata() {
    const videoElement = this.el.nativeElement;
    const videoWidth = videoElement.videoWidth;
    const videoHeight = videoElement.videoHeight;

    // Remove existing aspect ratio classes to avoid conflicts
    this.renderer.removeClass(videoElement, 'landscape-video');
    this.renderer.removeClass(videoElement, 'portrait-video');
    this.renderer.removeClass(videoElement, 'square-video');

    if (videoWidth > videoHeight) {
      // Landscape video
      this.renderer.addClass(videoElement, 'landscape-video');
    } else if (videoWidth < videoHeight) {
      // Portrait video
      this.renderer.addClass(videoElement, 'portrait-video');
    } else {
      // Square video
      this.renderer.addClass(videoElement, 'square-video');
    }
  }
}



@Directive({
  selector: '[appVideoAspectRatio1]'
})
export class VideoAspectRatioDirective1 {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('loadedmetadata')
  onLoadedMetadata() {
    const videoElement = this.el.nativeElement;
    const videoWidth = videoElement.videoWidth;
    const videoHeight = videoElement.videoHeight;

    // Remove existing aspect ratio classes to avoid conflicts
    this.renderer.removeClass(videoElement, 'landscape-video-inline');
    this.renderer.removeClass(videoElement, 'portrait-video-inline');
    this.renderer.removeClass(videoElement, 'square-video-inline');

    if (videoWidth > videoHeight) {
      // Landscape video
      this.renderer.addClass(videoElement, 'landscape-video-inline');
    } else if (videoWidth < videoHeight) {
      // Portrait video
      this.renderer.addClass(videoElement, 'portrait-video-inline');
    } else {
      // Square video
      this.renderer.addClass(videoElement, 'square-video-inline');
    }
  } 
}


@Directive({
  selector: '[appVideoAspectRatio2]'
})
export class VideoAspectRatioDirective2 {

  constructor(private el: ElementRef, private renderer: Renderer2) {
    // Initially hide the video element
    this.renderer.setStyle(this.el.nativeElement, 'visibility', 'hidden');
  }

  @HostListener('loadedmetadata')
  onLoadedMetadata() {
    const videoElement = this.el.nativeElement;
    const videoWidth = videoElement.videoWidth;
    const videoHeight = videoElement.videoHeight;

    // Remove existing aspect ratio classes to avoid conflicts
    this.renderer.removeClass(videoElement, 'landscape-video-popup');
    this.renderer.removeClass(videoElement, 'portrait-video-popup');
    this.renderer.removeClass(videoElement, 'square-video-popup');

    if (videoWidth > videoHeight) {
      // Landscape video
      this.renderer.addClass(videoElement, 'landscape-video-popup');
    } else if (videoWidth < videoHeight) {
      // Portrait video
      this.renderer.addClass(videoElement, 'portrait-video-popup');
    } else {
      // Square video
      this.renderer.addClass(videoElement, 'square-video-popup');
    }

    // Now that the aspect ratio has been calculated, display the video
    this.renderer.setStyle(videoElement, 'visibility', 'visible');
  }
}

